import { RangePickerProps } from "antd/lib/date-picker"
import moment from "moment"

const disabledPastDate: RangePickerProps["disabledDate"] = (current) =>
  current && current < moment().startOf("day")

export default disabledPastDate
